/*
 * BBC - Rap Map - App
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React, { useState, useEffect } from 'react';
import { debounce } from 'debounce';
import CalculateTrueHeight from '@mattgh9152/calculatetrueheight';

import Header from './components/Header';
import Map from './components/Map';
import Video from './components/Video';
import Logos from './components/Logos';

import getRappers from './utilities/GetRappers';
import enableTabbing from './utilities/EnableTabbing';

import './scss/style.scss';

const App = () => {
    const [video, setVideo] = useState(null);
    const [rappers, setRappers] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    const [season, setSeason] = useState(Number(new URLSearchParams(window.location.search).get('season')) || 3);
    const [selectedIndex, setSelectedIndex] = useState(null);

    const checkIfMobile = () => {
        if (window.innerWidth < 768) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };

    useEffect(() => {
        CalculateTrueHeight();

        window.addEventListener('resize', debounce(CalculateTrueHeight, 150), true);
        return () => window.removeEventListener('resize', CalculateTrueHeight, true);
    });

    useEffect(() => {
        checkIfMobile();

        window.addEventListener('resize', debounce(checkIfMobile, 150), true);
        return () => window.removeEventListener('resize', checkIfMobile, true);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        getRappers(season)
            .then(data => setRappers(data))
            .catch(err => console.error(err));

        enableTabbing();
    }, [season]);

    useEffect(() => {
        const checkURL = new URLSearchParams(window.location.search).get('v');
        const checkURLSeason = new URLSearchParams(window.location.search).get('season');

        if (checkURL !== '') {
            const videoToUse = rappers && checkURL !== null
                ? rappers.filter(rapper => rapper.id.toString() === checkURL.toString())
                : false;

            if (videoToUse) {
                setVideo(videoToUse[0]);
            }
        }

        if (checkURLSeason && checkURLSeason !== '') {
            setSeason(Number(checkURLSeason));
        }
    }, [rappers, season]);

    return (
        <div className={`App App__Season-${season}`}>
            <Header
                season={season}
                setSeason={setSeason}
                setSelectedIndex={setSelectedIndex}
            />
            <Map
                season={season}
                rappers={rappers}
                setVideo={setVideo}
                video={video}
                isMobile={isMobile}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
            />
            {video
                ? <Video video={video} setVideo={setVideo} season={season} />
                : ''
            }
            <Logos />

            <div className="seriesLink">
                <h3>Watch the BAFTA-Nominated series the rap game uk</h3>
                <a
                    href="https://www.bbc.co.uk/iplayer/episodes/p07jwq62/the-rap-game-uk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="Upload"
                >
                    Watch now
                </a>
            </div>
        </div>
    )
};


export default App;
